<template>
  <b-modal ref="fileModal" v-model="showModal" title="Anexar Arquivo">
    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      :style="isDragging && 'border-color: green'"
    >
      <input
        type="file"
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.ods,.mp3,.ogg,.mp4,.avi,.txt,.zip,.rar,.rem,.ced"
        multiple
        hidden="true"
      />
      <label for="fileInput" class="file-label">
        <div v-if="isDragging">Solte o arquivo!</div>
        <div v-else>
          Arraste o(s) arquivo(s) aqui ou <u>Clique aqui</u> para o subir o(s) arquivo(s).
        </div>
      </label>
      <div class="preview-container mt-4" v-if="files.length">
        <div class="preview-card" v-for="(file, index) in files" :key="index">
          <div>
            <p>
              {{ file.name }} ({{ (file.size / 1024 / 1024).toFixed(2) }} MB)
            </p>
          </div>
          <div>
            <button
              class="ml-2"
              type="button"
              @click="remove(index)"
              title="Remover arquivo"
            >
              <b>×</b>
            </button>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button
          type="button"
          class="btn btn-third btn-sm"
          @click="handleFileUpload"
          v-b-tooltip.hover
          title="Enviar"
        >
          <i class="fas fa-check-circle"></i
          ><span class="d-md-down-none">Enviar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'FileModal',
  data () {
    return {
      showModal: false,
      isDragging: false,
      files: [],
      maxFileSize: 50 * 1024 * 1024
    }
  },
  props: {
    reply: {
      type: Object,
      required: false,
      default: null
    }
  },
  methods: {
    show () {
      this.showModal = true
    },
    onChange () {
      const selectedFiles = Array.from(this.$refs.file.files)
      this.addFiles(selectedFiles)
    },
    dragover (e) {
      e.preventDefault()
      this.isDragging = true
    },
    dragleave () {
      this.isDragging = false
    },
    drop (e) {
      e.preventDefault()
      const droppedFiles = Array.from(e.dataTransfer.files)
      this.addFiles(droppedFiles)
      this.isDragging = false
    },
    addFiles (newFiles) {
      const totalSize =
          this.files.reduce((sum, file) => sum + file.size, 0) +
          newFiles.reduce((sum, file) => sum + file.size, 0)

      if (totalSize > this.maxFileSize) {
        alert('O tamanho total dos arquivos excede o limite de 50 MB.')
        return
      }

      this.files = [...this.files, ...newFiles]
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    handleFileUpload () {
      if (!this.files.length) return

      this.files.forEach(file => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          const fileInfo = {
            fileName: file.name,
            mimeType: file.type,
            fileBase: reader.result.split('base64,')[1],
            quotedMsg: this.getQuotedMsg()
          }
          let extension = this.getExtensionFromMimeType(file.type)

          if (file.name.endsWith('.rem') || file.name.endsWith('.ced')) {
            // fileInfo.fileName = file.name.replace(/\.rem$|\.ced$/, '.txt')
            fileInfo.mimeType = 'text/plain'
            extension = file.name.slice(-3)
          }

          if (
            [
              'pdf',
              'doc',
              'docx',
              'xls',
              'xlsx',
              'ppt',
              'pptx',
              'ods',
              'zip',
              'rar',
              'txt',
              'rem',
              'ced'
            ].includes(extension)
          ) {
            fileInfo.type = 'document'
            this.sendArchive(fileInfo)
          } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
            fileInfo.type = 'image'
            this.sendArchive(fileInfo)
          } else if (['mp3', 'ogg'].includes(extension)) {
            fileInfo.type = 'audio'
            this.sendAudio(fileInfo)
          } else if (['mp4', 'avi'].includes(extension)) {
            fileInfo.type = 'video'
            this.sendArchive(fileInfo)
          }
        }
        reader.onerror = error => {
          console.error('Error reading file:', error)
        }
      })

      this.files = []
      this.showModal = false
    },
    getExtensionFromMimeType (mimeType) {
      const mimeTypes = {
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            'xlsx',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            'pptx',
        'application/vnd.oasis.opendocument.spreadsheet': 'ods',
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'audio/mpeg': 'mp3',
        'audio/ogg': 'ogg',
        'video/mp4': 'mp4',
        'video/x-msvideo': 'avi',
        'text/plain': 'txt',
        'application/zip': 'zip',
        'application/x-rar-compressed': 'rar'
      }
      return mimeTypes[mimeType] || 'bin'
    },
    getQuotedMsg () {
      if (this.reply && this.reply.message) {
        return this.reply.message.messageId
      }
      return null
    },
    sendArchive (fileInfo) {
      this.$emit('sendFile', fileInfo)
    },
    sendImage (fileInfo) {
      this.$emit('sendImage', fileInfo)
    },
    sendAudio (fileInfo) {
      this.$emit('sendAudio', fileInfo)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/modal/FileModal.vue